import React from 'react';
import * as _ from 'lodash';
import {combineReducers} from 'redux';
import {connect, Provider} from 'react-redux';
import CarDamageStore from './CarDamageStore';
import {Box} from 'reactjs-admin-lte';

import {
  Button,
  ButtonToolbar,
  DropdownButton,
  SplitButton,
  MenuItem,
  ControlLabel,
  InputGroup,
  FormGroup,
  Row,
  Col,
  Form,
  FormControl,
  Tabs,
  Tab,
} from 'react-bootstrap';
import Select from 'react-select';
import FontAwsome from 'react-fontawesome';
import CarLayout
  from '../../component/element/CarDamageForm/CarLayout/CarLayout';
import WageItem from '../../component/element/CarDamageForm/WageItem/WageItem';
import PartItem from '../../component/element/CarDamageForm/PartItem/PartItem';
import DamageList
  from '../../component/element/CarDamageForm/DamageList/DamageList';
import StockList
  from '../../component/element/CarDamageForm/StockList/StockList';

import {
  loadDamageData,
} from '../../stores/CarDamage/DamageReducer';
import {
  loadFixLevelData,
} from '../../stores/CarDamage/FixLevelReducer';
import WorkdocStore from '../../stores/WorkdocStore';

import {
  updateCar,
} from '../../stores/CarDamage/CarReducer';

import {
  updateDamageItemByRowIndex
} from '../../stores/CarDamage/DamageReducer';

const NotificationSystem = require('react-notification-system');

const store = CarDamageStore();
const carLayout = connect(
    (state, props) => ({...state, ...props}))(CarLayout);

class CarDamageForm extends React.Component {

  tabs = [
    {
      'title': (<span><FontAwsome name="car" />{' '}รายการค่าแรง</span>),
      'content': (<WageItem />),
    },
    {
      'title': (<span><FontAwsome name="warning" />{' '}รายการอะไหล่(ตามรุ่นรถ)</span>),
      'content': (<PartItem />),
    },
    {
      'title': (<span><FontAwsome name="industry" />{' '}รายการในสต็อก</span>),
      'content': (<StockList />),
    },
  ];

  constructor(props) {
    super(props);

    this.state = {saving: false};
    props.dispatch(loadDamageData({
      wo: props.wo || '',
      category: '', query: '',
    }));

    props.dispatch(loadFixLevelData({
      wo: props.wo || '',
      category: '', query: '',
    }));

    if (this.props.view) {
      props.dispatch(updateCar({
        view: this.props.view,
      }));
    }
  }

  getFormData1() {
    const {props, state} = this;
    const {dispatch, damageList, car} = props;

    const total_wage = damageList.reduce(
        (sum, item) => sum + (parseFloat(item.wage_cost) || 0), 0);

    const total_part = damageList.reduce(
        // (sum, item) => sum + ((parseFloat(item.part_cost) || 0) *
        //                       (parseFloat(item.quantity) || 0)), 0);
        (sum, item) => sum + (parseFloat(item.part_cost) || 0), 0);

    const total_discount_wage = parseFloat(car.discount_wage_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_wage_cost) || 0),
                                    0);

    const total_discount_part = parseFloat(car.discount_part_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_part_cost) || 0),
                                    0);


    const wo = props.wo;
    let meta = {
      part_by: props.car.partBy,
      wage_price: total_wage,
      part_price: total_part,
      discount_part: total_discount_part,
      discount_wage: total_discount_wage,
    };
    let damage = [];
    _.each(damageList, (item) => {
      damage.push([
        item.seq || '',
        item.wage_itemnum || '',
        item.itemnum || '',
        item.detail || '',
        item.paint_flag == 1 ? 1 : 0, // เคาะ-พ่นสี
        item.fix_flag == 1 ? 1 : 0, // ซ่อม
        item.part_flag == 1 ? 1 : 0, // อะไหล่เปลี่ยน
        item.wait_insurer_flag == 1 ? 1 : 0,
        item.stock_flag == 1 ? 1 : 0,
        item.quantity,
        item.wage_cost || '',
        item.part_cost || '',
        item.bf_work_damage_id || '',
        item.prefer_repair == 1 ? 1 : 0, // ซ่อมจริง
      ].map(val => String(val)));
    });
    
    return {
      wo,
      damage,
      meta,
    };
  }

  getFormData2() {
    const {props, state} = this;
    const {dispatch, damageList, car} = props;

    const total_wage = damageList.reduce(
        (sum, item) => sum + (parseFloat(item.wage_cost) || 0), 0);
    const total_part = damageList.reduce(
        // (sum, item) => sum + ((parseFloat(item.part_cost) || 0) *
        //                       (parseFloat(item.quantity) || 0)), 0);
        (sum, item) => sum + (parseFloat(item.part_cost) || 0), 0);
    const total_discount_wage = parseFloat(car.discount_wage_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_wage_cost) || 0),
                                    0);

    const total_discount_part = parseFloat(car.discount_part_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_part_cost) || 0),
                                    0);

    const wo = props.wo;
    let meta = {
      view: car.view,
      part_by: car.partBy,
      wage_price: total_wage,
      part_price: total_part,
      discount_part: total_discount_part,
      discount_wage: total_discount_wage,
    };
    let wage_list = [];
    let part_list = [];
    _.each(damageList, (item) => {
      if (item.paint_flag == 1 || item.fix_flag == 1 || item.wage_flag == 1) {
        wage_list.push({
          wage_itemnum: item.wage_itemnum || '',
          detail: item.detail || '',
          quantity: item.quantity || '',
          discount_percent: item.discount_wage_percent || '',
          discount_amount: item.discount_wage_cost || '',
          wage_cost: item.net_wage_cost || '',
          amount: item.net_wage_cost || '',
          paint_flag: item.paint_flag == 1 ? 1 : 0,
          fix_flag: item.fix_flag == 1 ? 1 : 0,
          price_per_unit: item.wage_cost || '',
          part_by: item.part_by || '',
          prefer_repair: item.prefer_repair == 1 ? 1 : 0,
        });
      }
      if (item.part_flag == 1 || item.stock_flag == 1 || item.parts_flag == 1) {
        part_list.push({
          itemnum: item.itemnum || '',
          detail: item.detail || '',
          quantity: item.quantity || '',
          discount_percent: item.discount_part_percent || '',
          discount_amount: item.discount_part_cost || '',
          part_cost: item.net_part_cost || '',
          amount: item.net_part_cost || '',
          part_flag: item.part_flag == 1 ? 1 : 0,
          stock_flag: item.stock_flag == 1 ? 1 : 0,
          price_per_unit: item.part_cost || '',
          part_by: item.part_by || '',
          prefer_repair: item.prefer_repair == 1 ? 1 : 0,
        });
      }
    });

    return {
      wo,
      wage_list,
      part_list,
      meta,
    };
  }

  getFormData3() {
    const {props, state} = this;
    const {dispatch, damageList, car} = props;

    const total_wage = damageList.reduce(
        (sum, item) => sum + (parseFloat(item.wage_cost) || 0), 0);
    const total_part = damageList.reduce(
        // (sum, item) => sum + ((parseFloat(item.part_cost) || 0) *
        //                       (parseFloat(item.quantity) || 0)), 0);
        (sum, item) => sum + (parseFloat(item.part_cost) || 0), 0);
    const total_discount_wage = parseFloat(car.discount_wage_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_wage_cost) || 0),
                                    0);

    const total_discount_part = parseFloat(car.discount_part_cost) ||
                                damageList.reduce((sum, item) =>
                                    sum +
                                    (parseFloat(item.discount_part_cost) || 0),
                                    0);


    const wo = props.wo;
    let meta = {
      part_by: props.car.partBy,
      wage_price: total_wage,
      part_price: total_part,
      discount_part: total_discount_part,
      discount_wage: total_discount_wage,
    };
    let damage = [];
    _.each(damageList, (item) => {
      damage.push([
        item.seq || '',
        item.wage_itemnum || '',
        item.itemnum || '',
        item.detail || '',
        item.paint_flag == 1 ? 1 : 0, // เคาะ-พ่นสี
        item.fix_flag == 1 ? 1 : 0, // ซ่อม
        item.part_flag == 1 ? 1 : 0, // อะไหล่เปลี่ยน
        item.wait_insurer_flag == 1 ? 1 : 0,
        item.stock_flag == 1 ? 1 : 0,
        item.quantity,
        item.wage_cost || '',
        item.part_cost || '',
        item.bf_work_damage_id || '',
        item.prefer_repair == 1 ? 1 : 0, // ซ่อมจริง
        item.fixlevel || ''
      ].map(val => String(val)));
    });
    
    return {
      wo,
      damage,
      meta,
    };
  }

  handleSaveForm = (e) => {
    let {damageList} = this.props
    // damageList.map((item,index)=>{
    //   if (item.wage_cost.indexOf(',')!=-1)
    //     item.wage_cost = item.wage_cost.replace(/,/g, '')
    //   if (item.part_cost.indexOf(',')!=-1)
    //     item.part_cost = item.part_cost.replace(/,/g, '')
    //   if (item.price_per_unit.indexOf(',')!=-1)
    //     item.price_per_unit = item.price_per_unit.replace(/,/g, '')
    //   return item
    // })
    this.setState({saving: true});
    switch (parseInt(this.props.car.view)) {
      case 1:
        // console.log('this.getFormData1()=>',this.getFormData1())
        WorkdocStore.saveWorkdocDamage(
            this.getFormData1(),
            this.onSaveSuccess,
            this.onSaveFail,
        );
        break;
      case 2:
        WorkdocStore.saveWorkdocDamage2(
            this.getFormData2(),
            this.onSaveSuccess,
            this.onSaveFail,
        );
        break;
      case 3:
        // console.log('this.getFormData3()=>',this.getFormData3())
        WorkdocStore.saveWorkdocDamage(
            this.getFormData3(),
            this.onSaveSuccess((result)=>{
              if (result.status=='OK') {
                result.data.forEach((item,index)=>{
                  if (this.props.damageList[index].bf_work_damage_id==undefined||this.props.damageList[index].bf_work_damage_id==''||this.props.damageList[index].bf_work_damage_id==null) {
                    this.props.damageList[index] = Object.assign(this.props.damageList[index], {bf_work_damage_id: item.bf_work_damage_id});
                    let updated = this.props.damageList[index]
                    let row = index
                    this.props.dispatch(updateDamageItemByRowIndex({
                        row,
                        updated,
                    }));
                  }  
                })
              }
            }),
            this.onSaveFail,
        );
        break;  
      default:
        break;
    }

  };

  onSaveSuccess = (e) => {
    this.setState({saving: false});
    this.refs.notificationSystem.addNotification({
      title: 'แจ้งเตือน',
      message: 'ทำการบันทึกข้อมูลรายการความเสียหาย เลขที่ ' + this.props.wo +
               ' เรียบร้อย',
      level: 'success',
      position: 'tc',
    });
    return e
  };

  onSaveFail = (e) => {
    this.setState({saving: false});
    // console.error('save fail', e);
    this.refs.notificationSystem.addNotification({
      title: 'แจ้งเตือน',
      message: 'เกิดข้อผิดพลาดระหว่างการบันทึกข้อมูลความเสียหาย เลขที่ ' +
               this.props.wo,
      level: 'error',
      position: 'tc',
    });
  };

  handleCloseForm = (e) => {

  };

  render() {
    return (
        <div className={''}>
          <Box loading={this.state.saving}>
            <Box.Body>
              <Row>
                <Col className={'float-left text-center'}
                     style={{padding: 10 + 'px', width: '300px'}}>
                  <CarLayout />
                </Col>
                <Col className={'float-left'}
                     style={{width: 'calc(100% - 300px)'}}>
                  <Tabs id={'car_damage_tabs'}
                        defaultActiveKey={0}
                        onSelect={() => setTimeout(
                            () => window.dispatchEvent(new Event('resize')),
                            500)}
                  >
                    {this.tabs.map((item, index) => (
                        <Tab key={index}
                             eventKey={index} title={item.title}>
                          {item.content}
                        </Tab>
                    ))}
                  </Tabs>
                </Col>
                <div className={'clear-fix'}></div>
              </Row>
              <Row>
                <Col md={12}>
                  <DamageList />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroup className={'text-right'}>
                    <label style={{'marginRight': '10px'}}>
                      <input type={'checkbox'} name={'has_discount'}
                             checked={this.props.car.hasDiscount}
                             onChange={(e) => {
                               const hasDiscount = e.target.checked;
                               this.props.dispatch(updateCar({hasDiscount}));
                             }}
                      /> มีส่วนลด
                    </label>
                    <Button
                        bsStyle={'primary'}
                        onClick={this.handleSaveForm}
                    >
                      <FontAwsome name={'save'} /> บันทึก
                    </Button>
                    {' '}
                    <Button
                        bsStyle={'default'}
                        onClick={this.handleCloseForm}
                    >
                      <FontAwsome name={'close'} /> ปิดใบงาน
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </Box.Body>
          </Box>

          <NotificationSystem ref="notificationSystem" />
        </div>
    );
  }

}

export default connect(
    (state, props) => ({...state, ...props}))(CarDamageForm);


// WEBPACK FOOTER //
// ./src/view/workdoc/CarDamageForm.js